export default __webpack_public_path__ + "static/media/F1_3.66e036ef.png";